import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { SiteLayout } from './components/layout/SiteLayout';
import { Home } from './pages/Home';
import { Events } from './pages/Events';
import { About } from './pages/About';
import { MeetTheTeam } from './pages/MeetTheTeam';
import { Photos } from './pages/Photos';
import { LocalChurches } from './pages/LocalChurches';
import { Connect } from './pages/Connect';
import { Give } from './pages/Give';
import { NotFound } from './pages/NotFound';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2mjpuxc3z38e8">
      <Routes data-id="element-1" data-mp="31aqdi9yfoio3">
        <Route element={<SiteLayout data-id="element-3" data-mp="31ayqs2ygxpzt" />} data-id="element-2" data-mp="31agq8u4rwpm3">
          <Route path="/" element={<Home data-id="element-5" data-mp="31ctetq51dy84" />} data-id="element-4" data-mp="31c9w477kb5t1" />
          <Route path="/events" element={<Events data-id="element-7" data-mp="2wiyy8vkq9zd9" />} data-id="element-6" data-mp="2wka18t6cn33b" />
          <Route path="/about" element={<About data-id="element-9" data-mp="2wi5mfg6wwjo9" />} data-id="element-8" data-mp="2wifh3h2wjf0a" />
          <Route path="/meet-the-team" element={<MeetTheTeam data-id="element-11" data-mp="28t4j27cxrypu" />} data-id="element-10" data-mp="28tw6guwdqq51" />
          <Route path="/photos" element={<Photos data-id="element-13" data-mp="23vkzcrxgytqi" />} data-id="element-12" data-mp="28sbend1g9lav" />
          <Route path="/local-churches" element={<LocalChurches data-id="element-15" data-mp="23t8iki3g6pf1" />} data-id="element-14" data-mp="23u9uspw79hyc" />
          <Route path="/connect" element={<Connect data-id="element-17" data-mp="3iiwg8rrbto4t" />} data-id="element-16" data-mp="3ik7eyd5x05p2" />
          <Route path="/give" element={<Give data-id="element-19" data-mp="3mljat0fdtn5p" />} data-id="element-18" data-mp="3ijpc2xoqyt86" />
          {/* Legacy WordPress route */}
          <Route path="/contact-us" element={<Navigate to="/connect" replace data-id="element-21" data-mp="3rc9f0ac2njyt" />} data-id="element-20" data-mp="3mjztr7lwj82v" />
          <Route path="*" element={<NotFound data-id="element-23" data-mp="3rd19fhtxnbni" />} data-id="element-22" data-mp="3rdki07xp0nov" />
        </Route>
      </Routes>
    </BrowserRouter>;
}